export function formatCurrency(amount, currency = 'EUR') {
  if (amount === null || amount === undefined) return '—';
  try {
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${currency}${Number(amount).toFixed(2)}`;
  }
}

export function formatDate(isoDate) {
  if (!isoDate) return '—';
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return isoDate;
  return d.toLocaleDateString('en-GB', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function daysAgo(isoDate) {
  if (!isoDate) return '';
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return '';
  const diff = Math.round((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
  if (diff <= 0) return 'today';
  return `${diff} day${diff === 1 ? '' : 's'} ago`;
}

export function getAgeingText(ageing) {
  if (ageing === null || ageing === undefined) return null;
  if (ageing === 0) return 'Today';
  if (ageing > 0) return `${ageing} day${ageing === 1 ? '' : 's'} remaining`;
  return `${Math.abs(ageing)} day${Math.abs(ageing) === 1 ? '' : 's'} overdue`;
}

// Tone thresholds mirror the internal admin Orders page; the colors
// themselves are mapped to this app's own theme tokens (pink/amber/green)
// instead of the admin page's raw hex values.
export function getAgeingTone(ageing) {
  if (ageing === null || ageing === undefined) return null;
  if (ageing < 0) return 'overdue';
  if (ageing > 14) return 'ontrack';
  return 'warning';
}
